// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"652":"28a818e6","787":"5e2aa74d","854":"f66fe7b5"}[chunkId] + ".chunk.js";
};